// extracted by css-extract-rspack-plugin
export default {"btn_contain":"btn_contain___ghoB8","rule_btn":"rule_btn___20Hld"};